import React from 'react'

function AccountSummary({ title, credits, debits, net }) {
  return (
    <div className="flex-1 bg-background rounded-lg px-4 pb-2">
      <p className="text-base text-secondary border-b border-border-lines py-3.5">{title}</p>
      <div className="flex text-base border-b border-border-lines py-2">
        <p className="w-[140px] text-secondary">Credits</p>
        <p className="text-success">{credits}</p>
      </div>
      <div className="flex text-base border-b border-border-lines py-2">
        <p className="w-[140px] text-secondary">Debits</p>
        <p className="text-danger">{debits}</p>
      </div>
      <div className="flex text-base font-semibold py-2">
        <p className="w-[140px] text-secondary font-normal">Net</p>
        <p className="text-success">{net}</p>
      </div>
    </div>
  )
}

export default function TransactionSummaryPanel({ summary }) {
  return (
    <div className="flex-1 min-w-0 bg-white border border-border-lines rounded-2xl p-4 flex flex-col gap-4">
      <p className="text-base font-semibold text-dark-blue">TRANSACTION SUMMARY</p>

      <div className="flex flex-col md:flex-row gap-4">
        <AccountSummary title="CREDIT ACCOUNT" {...summary.creditAccount} />
        <AccountSummary title="PRIZE NET MOVEMENT" {...summary.prizeNetMovement} />
      </div>

      <div className="bg-background rounded-lg p-4">
        <p className="text-base text-secondary">OVERALL NET MOVEMENT</p>
        <p className="text-2xl font-semibold text-success">{summary.overallNetMovement.value}</p>
        <p className="text-base text-secondary">{summary.overallNetMovement.hint}</p>
      </div>
    </div>
  )
}
